/* eslint-disable prefer-const */
import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';

import { AppUtilityService } from 'src/app/app-utility.service';
import { LMSDialogHandlerService } from 'src/app/shared/lmsdialog-handler.service';
import { MdbSelectModule } from 'src/lib/mdb5-adapted/public-api';

import { LMSConstantsService } from '@lmsConstants';
import { RatesAndFeesModel } from '@lmsModels';
import { RatesAdnFeesService } from '@lmsrestServices';

import { AddLoanTypeComponent } from './add-loan-type/add-loan-type.component';
import { RemoveLoanTypeDialogComponent } from './remove-loan-type/remove-loan-type.component';

@Component({
  selector: 'app-rates-and-fees',
  templateUrl: './rates-and-fees.component.html',
  styleUrls: ['./rates-and-fees.component.scss'],
  standalone: true,
  imports: [CommonModule,FormsModule, ReactiveFormsModule, MdbSelectModule]
})
export class RatesAndFeesComponent implements OnInit {

  ratesAndFeesForm: FormGroup;

  submitted = false;
  panelOpenState = false;
  myControl = new FormControl('');
  //RATES AND FEES MODEL
  ratesAndFeesModel = new RatesAndFeesModel();
  lstProductTypes: any[] = [];
  //lstProducts: Array<any> = [];
  // product: any;
  lmsUserProfile: any;
  lstmyBenefitTier = this.lmsConstantService.getLMSConstant('MYBENEFIT_TIER');

  constructor(
    private fb: FormBuilder,
    public ratesAndFeesService: RatesAdnFeesService,
    public global_utility: AppUtilityService,
    public lmsDialogHandler: LMSDialogHandlerService,
    private changeDetector: ChangeDetectorRef,
    private lmsConstantService: LMSConstantsService
  ) { }

  ngOnInit(): void {
    this.ratesAndFeesForm = this.fb.group({

      //'id': [this.ratesAndFeesModel.id, [Validators.required]],
      'code': [this.ratesAndFeesModel.code, [Validators.required]],
      'description': [this.ratesAndFeesModel.description, [Validators.required]],
      'type': [this.ratesAndFeesModel.type, [Validators.required]],
      'regulatoryType': [this.ratesAndFeesModel.regulatoryType],
      'minimumLoan': [this.ratesAndFeesModel.minimumLoan, [Validators.required]],
      'maximumLoan': [this.ratesAndFeesModel.maximumLoan, [Validators.required]],

      'interestRate1st': [this.ratesAndFeesModel.interestRate1st, [Validators.required]],
      'interestRateOther': [this.ratesAndFeesModel.interestRateOther, [Validators.required]],
      'initFeeBelow1000': [this.ratesAndFeesModel.initFeeBelow1000],
      'initFeeFirst1000': [this.ratesAndFeesModel.initFeeFirst1000],
      'initiationFee': [this.ratesAndFeesModel.initiationFee, [Validators.required]],
      'initiationCap': [this.ratesAndFeesModel.initiationCap, [Validators.required]],
      'includeVatInCalculation': [this.ratesAndFeesModel.includeVatInCalculation],

      'myBenefits': [this.ratesAndFeesModel.myBenefits, [Validators.required]],

      'factor1stLoan': [this.ratesAndFeesModel.factor1stLoan],
      'factorOtherLoan': [this.ratesAndFeesModel.factorOtherLoan],
      'factorUpTo850': [this.ratesAndFeesModel.factorUpTo850],
      'factorUpTo1000': [this.ratesAndFeesModel.factorUpTo1000],
      'initServiceFeeCap': [this.ratesAndFeesModel.initServiceFeeCap, [Validators.required]],
      'term': [this.ratesAndFeesModel.term, [Validators.required]],
      'monthlyServiceFee': [this.ratesAndFeesModel.monthlyServiceFee, [Validators.required]],
      'maxDays': [this.ratesAndFeesModel.maxDays, [Validators.required]],

      'calculationType': [this.ratesAndFeesModel.calculationType],
      'includeInInterestCalc': [this.ratesAndFeesModel.includeInInterestCalc],
      'includeVatInCalc': [this.ratesAndFeesModel.includeVatInCalc],
      'mybenefitsTier': [this.ratesAndFeesModel.mybenefitsTier]
    });

    this.findAllProducts();
  }

  // public lstIncludeInCalculation = YESNO;
  public lstMyBenefitTier = inject(LMSConstantsService).getLMSConstant('MYBENEFIT_TIER');

  public lstRegulatory: any[] = [
    { value: "ShortTerm", description: "Short Term" },
    { value: "MediumTerm", description: "Medium Term" },
    { value: "LongTerm", description: "Long Term" },
  ];

  ngAfterContentChecked(): void {
    this.changeDetector.detectChanges();
  }

  findAllProducts() {
    this.ratesAndFeesService.findAllProducts().subscribe((result: any) => {
      this.lstProductTypes = result;
      this.ratesAndFeesModel = this.lstProductTypes[0];
      this.ratesAndFeesForm.get("mybenefitsTier")?.setValue(this.ratesAndFeesModel.mybenefitsTier);
    });
  }

  onSelect(event: any) {
    //this.findProductByDescription(event);
    this.ratesAndFeesModel.mybenefitsTier = Number(event.target.value);
  }

  findProductByDescription(data: any) {
    for (const product of this.lstProductTypes) {
      if (product.description == data) {
        this.ratesAndFeesModel = product;
        this.ratesAndFeesForm.get("mybenefitsTier")?.setValue(this.ratesAndFeesModel.mybenefitsTier);
      }
    }
  }

  showProduct(product: RatesAndFeesModel) {
    this.ratesAndFeesModel = product;
    this.ratesAndFeesForm.get("mybenefitsTier")?.setValue(this.ratesAndFeesModel.mybenefitsTier);
  }

  openAddProductDialog() {
    const dialogRef = this.global_utility.displayDialogData2(AddLoanTypeComponent, {
      backdrop: true, ignoreBackdropClick: true, keyboard: true, nonInvasive: false, animation: false,
      //modalClass: 'modal-dialog modal-lg modal-fluid modal-dialog-centered  d-flex d-flex-md',
      modalClass: 'modal modal-fluid modal-lg modal-dialog modal-dialog-centered  modal-dialog-scrollable',
      containerClass: 'frame'
    });

    dialogRef.onClose.subscribe(result => {
      if (result != null) {
        result.createdBy = this.global_utility.getGlobalData('userDisplay');
        result.createdOn = Date.now();

        this.ratesAndFeesService.saveProduct(result).subscribe((res => {
          this.ratesAndFeesModel = res;
          this.findAllProducts();
          console.log("Loan type created successfully...");
        }));
      }
    });
    // });
  }

  openDeleteProductDialog(rateandFee: any) {
    if (!rateandFee) {
      console.log("Nothing will be removed , nothing selected...");
      return;
    }

    const dialogRef = this.global_utility.displayDialogData2(RemoveLoanTypeDialogComponent, {
      backdrop: true, ignoreBackdropClick: true, keyboard: true, nonInvasive: false, animation: false,
      //modalClass: 'modal-dialog modal-lg modal-fluid modal-dialog-centered  d-flex d-flex-md',
      modalClass: 'modal modal-fluid modal-lg modal-dialog modal-dialog-centered  modal-dialog-scrollable',
      containerClass: 'frame',
      data: { loanTypeData: this.ratesAndFeesModel }
    });

    dialogRef.onClose.subscribe(result => {
      if (result) {
        result.id = this.ratesAndFeesService.setProductData(this.ratesAndFeesModel);
        result.userName = this.global_utility.getGlobalData('userDisplay');

        this.ratesAndFeesService.removeLoanType(this.ratesAndFeesService.getProductData()).subscribe((dlgresult: any) => {
          if (dlgresult) {
            this.lstProductTypes = dlgresult;
            console.log("Product remove successful...");
            // this.findAllProducts();
          }
        });
      }
    });
  }

  saveUpdateLoanType(product: any) {
    this.submitted = true;
    this.ratesAndFeesModel.updatedBy = this.global_utility.getGlobalData('userDisplay');

    //TODO0
    if (this.ratesAndFeesForm.valid) {
      this.ratesAndFeesService.updateProduct(this.ratesAndFeesModel).subscribe((res => {
        if (res) {
          this.ratesAndFeesService.setProductData = res;
          this.lstProductTypes.map((prod: RatesAndFeesModel) => {
            if (prod.id == res.id) {
              this.ratesAndFeesModel = res;
              prod = this.ratesAndFeesModel;
            }
          });
          this.global_utility.success(`Product ${res.description} update successful.`, 'Product Update');
        }
      }));
    }
  }

  get validateRatesAndFeesValues() {
    return this.ratesAndFeesForm.controls;
  }

}
